
define('modules/application/wizard/steps/zoneStep/complexZoneStep/intrusionDetectionZoneStep/zoneDetailView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  // Classes
  "../zoneDetailView",
  "../../../../classes/series",
  "../../../../classes/inserters",
  "../../../../classes/deinserters",
  "../../../../classes/technicalBusAlarm",
  "../../../../classes/technicalRadioAlarm",
  "../../../../classes/volumetricProtection",
  "../../../../classes/radioSensors",
  "../../../../classes/perimetralProtection"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneDetailView,
  series,
  inserters,
  deinserters,
  technicalBusAlarm,
  technicalRadioAlarm,
  volumetricProtection,
  radioSensors,
  perimetralProtection) {

  // Creating a single zone model
  var intrusionDetectionZoneDetailView               = ZoneDetailView.extend({
    sectionInstancer        : function(section)   {
      switch(section.name)
      {
        case "series"               : return series;
        case "inserters"            : return inserters;
        case "deinserters"          : return deinserters;
        case "technicalBusAlarm"    : return technicalBusAlarm;
        case "technicalRadioAlarm"  : return technicalRadioAlarm;
        case "volumetricProtection" : return volumetricProtection;
        case "radioSensors"         : return radioSensors;
        case "perimetralProtection" : return perimetralProtection;
      }
    }
  });

  // Required, return the module for AMD compliance
  return intrusionDetectionZoneDetailView;
});